import React, { useEffect, useState } from "react";
import { TbDownload, TbLogs } from "react-icons/tb";
import LineChartStatus from "../../Components/Charts/LineChart";
import { IoChevronDown, IoChevronUp, IoReload } from "react-icons/io5";
import FormatDateTime from "../../Functions/FormatDate";
import SingleLoaderItem from "../../Loaders/SingleLoaderItem";
import { Dropdown } from "react-bootstrap";
import BarChartTime from "../../Components/Charts/BarChart";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ApiRequests = ({
    account_id,
    data,
    loading,
}) => {
    const {t} = useLanguage()
    const [openLog, setOpenLog] = useState("")
    const [apiLogs, setApiLogs] = useState([])
    const [loadingLogs, setLoadingLogs] = useState(false)
    const [selectedItem, setSelectedItem] = useState({})
    const [selectedItemId, setSelectedItemId] = useState(null)
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const getApiLogs = async (api_id) => {
        setLoadingLogs(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_api_logs`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    api_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setApiLogs(data.data)
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingLogs(false);
        }
    };

    useEffect(() => {
        if (data) {
            setSelectedItem(data[0])
            setSelectedItemId(data[0]?.id)
            getApiLogs(data[0]?.id)
        }
    }, [data])

    return (
        <div className="analytics_cont_body_inner">
            <div className="analytics_cont_body_inner_chart_cont">
                <div className="chart_header">
                    <p className="chart_header_title fade-in">{t.analytics.total_requests}</p>
                    {data.length > 0 && (
                        <div className="chart_header_last">
                            <Dropdown autoClose={"outside"}>
                                <Dropdown.Toggle
                                    as="div"
                                    className="analytics_cont_header_title_btn fade-in"
                                >
                                    {data
                                        .filter(singleItem => selectedItemId === singleItem.id)
                                        .map(singleItem => singleItem.name)
                                        .join(", ") || t.select
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="custom_dropdown_menu">
                                    <div className="dropdown_container fade-in">
                                        {data.map((singleItem) => (
                                            <button
                                                key={singleItem.id}
                                                onClick={() => { setSelectedItemId(singleItem.id); setSelectedItem(singleItem); getApiLogs(singleItem.id) }}
                                                className={`settings_link ${selectedItemId == singleItem.id && "settings_link_selected"}`}
                                            >
                                                {singleItem.name}
                                            </button>
                                        ))}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    )}
                </div>

                <div className="chart_cont fade-in">
                    <BarChartTime data={selectedItem ? [selectedItem] : []} loading={loading} />
                </div>
            </div>

            <div className="analytics_api_req_logs_cont fade-in">
                <div className="analytics_api_req_logs_cont_header fade-in">
                    <p>
                        <TbLogs />
                        {t.analytics.activity_logs}
                    </p>
                    <div className="editor_terminal_header_btn_cont">
                        <button className="main_mcp_cont_chat_btn" onClick={()=> getApiLogs(selectedItemId)}>
                            {loadingLogs ? (
                                <Spinner loading={true}/>
                            ):(
                                <IoReload />
                            )}
                        </button>
                    </div>
                </div>
                <div className="terminal_cont_item_container">
                    {loadingLogs ? (
                        <SingleLoaderItem length={3} />
                    ) : (
                        apiLogs.length > 0 ? (
                            apiLogs.map((log) => (
                                <div key={log.id} className="terminal_cont_item">
                                    <div className="terminal_cont_item_header">
                                        <button
                                            className="terminal_cont_item_btn"
                                            onClick={() =>
                                                setOpenLog(openLog === log.id ? null : log.id)
                                            }
                                        >
                                            {openLog === log.id ? (
                                                <IoChevronUp />
                                            ) : (
                                                <IoChevronDown />
                                            )}
                                        </button>
                                        <p className={`log_message fade-in ${log.severity == 2 ? "log_message_red" : ""}`}><span>{FormatDateTime(log.created_at)}</span>

                                            {log.severity != 2 ? (
                                                <> - {log.message}</>
                                            ) : (
                                                <> - {t.error_occurred}</>
                                            )

                                            } </p>
                                    </div>

                                    <div
                                        className={`terminal_cont_item_cont ${openLog === log.id ? "terminal_cont_item_cont_open" : ""
                                            } ${openLog === log.id && log.severity == 2 ? "terminal_cont_item_cont_red" : ""}`}
                                    >
                                        <pre>
                                            {JSON.stringify(
                                                {
                                                    ...(log || {}),
                                                    created_at: log?.created_at
                                                        ? FormatDateTime(log.created_at)
                                                        : log?.created_at
                                                },
                                                null,
                                                2
                                            )}
                                        </pre>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="terminal_cont_item_container">
                                <div className="no_log_terminal_cont_item">
                                    {t.no_logs}
                                </div>
                            </div>
                        )
                    )}



                </div>

            </div>
        </div>
    );
};

export default ApiRequests;